import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';

const BlogDetail = () => {
  const { id } = useParams();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const cleanHTML = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    doc.querySelectorAll('*').forEach((el) => {
      el.removeAttribute('style');
      el.removeAttribute('class');
    });
    return doc.body.innerHTML;
  };

  useEffect(() => {
    if (!id) {
      setError('Invalid blog URL.');
      setLoading(false);
      return;
    }

    const fetchBlogDetail = async () => {
      try {
        const response = await fetch(
          `https://petcrew.in/app-admin/api/blog.php?type=details&post_id=${id}`
        );
        const data = await response.json();

        if (data.Error === 'False' && Array.isArray(data.Data) && data.Data.length > 0) {
          const blogData = data.Data[0];
          const cleanedDesc = cleanHTML(blogData.desc);
          setBlog({ ...blogData, desc: cleanedDesc });
        } else {
          throw new Error(data.Message || 'Blog not found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogDetail();
  }, [id]);

  if (loading) return <p className="text-center mt-5">Loading blog...</p>;
  if (error) return <p className="text-danger text-center mt-5">Error: {error}</p>;
  if (!blog) return <p className="text-center mt-5">No blog found.</p>;

  return (
    <>
    <Helmet>
        <title>{blog.title}</title>
        <meta
          name="description"
          content={blog.desc.replace(/<[^>]+>/g, '').slice(0, 150)}
        />
        <meta property="og:title" content={blog.title} />
        <meta
          property="og:description"
          content={blog.desc.replace(/<[^>]+>/g, '').slice(0, 150)}
        />
        <meta property="og:image" content={blog.image_link} />
        <meta property="og:type" content="article" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": window.location.href,
            },
            "headline": blog.title,
            "image": blog.image_link,
            "author": {
              "@type": "Organization",
              "name": "PetCrew"
            },
            "publisher": {
              "@type": "Organization",
              "name": "PetCrew",
              "logo": {
                "@type": "ImageObject",
                "url": "https://petcrew.in/logo.png" // Replace with your actual logo URL
              }
            },
            "datePublished": blog.posted_on,
            "description": blog.desc.replace(/<[^>]+>/g, '').slice(0, 150),
          })}
        </script>
      </Helmet>
      <Header />
      <main style={styles.container} className='blog-detail-container'>
        <h1 style={styles.title}>{blog.title}</h1>
        <p style={styles.date}>{blog.posted_on}</p>
        {blog.image_link && (
          <div style={styles.imageContainer}>
            <img src={blog.image_link} alt={blog.title} style={styles.image} />
          </div>
        )}
        <section style={styles.content}>
          <div dangerouslySetInnerHTML={{ __html: blog.desc }} />
        </section>
      </main>
      <Footer />
    </>
  );
};

const styles = {
  container: {
    maxWidth: '800px',
    margin: '40px auto',
    padding: '0 20px',
    fontFamily: 'Arial, sans-serif',
    color: '#333',
    lineHeight: 1.6,
  },
  title: {
    fontSize: '32px',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  date: {
    color: '#888',
    fontSize: '14px',
    marginBottom: '20px',
  },
  imageContainer: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  image: {
    width: '100%',
    maxHeight: '400px',
    objectFit: 'cover',
    borderRadius: '8px',
  },
  content: {
    fontSize: '16px',
  },
};

export default BlogDetail;
